import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { AccessPortal, BackdropLoader, DatePicker, getUtility, Icon, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Divider, FormControlLabel, FormGroup, List, ListItem, IconButton, Switch, ToggleButton, ToggleButtonGroup, Typography, Chip } from '@mui/material';
import { formatISO } from 'date-fns';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListStatusHeader from 'src/components/general/ListStatusHeader';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import useStyles from '../styles';
import Utility from './Utility';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { RESIDENCY_ADDRESS_STATUS } from 'src/constants/residency';
import BillingSettingsCustomFee from './BillingSettingsCustomFee';
export const BillingSettingsTab = observer(_ref => {
  var _store$homeDashboardS;
  let residencyId = _ref.residencyId,
    accountId = _ref.accountId,
    propertyId = _ref.propertyId,
    handleTabChange = _ref.handleTabChange,
    isOpen = _ref.isOpen,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customAdminFee = _useState2[0],
    setCustomAdminFee = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customLateFee = _useState4[0],
    setCustomLateFee = _useState4[1];
  const _useState5 = useState(FEE_UNIT_TYPES.fixedAmount),
    _useState6 = _slicedToArray(_useState5, 2),
    customLateFeeSign = _useState6[0],
    setCustomLateFeeSign = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    email = _useState8[0],
    setEmail = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    feeIsUpdated = _useState0[0],
    setFeeIsUpdated = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    fetchAdminFee = _useState10[0],
    setFetchAdminFee = _useState10[1];
  const _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    fetchLateFee = _useState12[0],
    setFetchLateFee = _useState12[1];
  const _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    newEmail = _useState14[0],
    setNewEmail = _useState14[1];
  const _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    addresses = _useState16[0],
    setAddresses = _useState16[1];
  const _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    startDate = _useState18[0],
    setStartDate = _useState18[1];
  const _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isLoading = _useState20[0],
    setIsLoading = _useState20[1];
  const _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    accessDate = _useState22[0],
    setAccessDate = _useState22[1];
  const _useState23 = useState('bill'),
    _useState24 = _slicedToArray(_useState23, 2),
    enrollType = _useState24[0],
    setEnrollType = _useState24[1];
  const _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    settingsList = _useState26[0],
    setSettingsList = _useState26[1];
  const _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    accessEmail = _useState28[0],
    setAccessEmail = _useState28[1];
  const _useState29 = useState(t('unit_modal.same_as_property_address')),
    _useState30 = _slicedToArray(_useState29, 2),
    propertyAddress = _useState30[0],
    setPropertyAddress = _useState30[1];
  const _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    propertyAdminFee = _useState32[0],
    setPropertyAdminFee = _useState32[1];
  const _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    propertyLateFee = _useState34[0],
    setPropertyLateFee = _useState34[1];
  const _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    accessDateAsync = _useState36[0],
    setAccessDateAsync = _useState36[1];
  const _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    settingsEditMode = _useState38[0],
    setSettingsEditMode = _useState38[1];
  const _useState39 = useState(null),
    _useState40 = _slicedToArray(_useState39, 2),
    companyData = _useState40[0],
    setCompanyData = _useState40[1];
  const _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2),
    paperStatementGl = _useState42[0],
    setPaperStatementGl = _useState42[1];
  const _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    showPaperStatementMessage = _useState44[0],
    setShowPaperStatementMessage = _useState44[1];
  const _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    showCompanyAddressMessage = _useState46[0],
    setShowCompanyAddressMessage = _useState46[1];
  const _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    automaticallySendPaperInvitations = _useState48[0],
    setAutomaticallySendPaperInvitations = _useState48[1];
  const _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    automaticallySendPaperStatements = _useState50[0],
    setAutomaticallySendPaperStatements = _useState50[1];
  const _useState51 = useState(''),
    _useState52 = _slicedToArray(_useState51, 2),
    paperInviteLastSent = _useState52[0],
    setPaperInviteLastSent = _useState52[1];
  const _useState53 = useState('custom-date'),
    _useState54 = _slicedToArray(_useState53, 2),
    portalAccess = _useState54[0],
    setPortalAccess = _useState54[1];
  const handlePortalAccessChange = (e, value) => {
    setPortalAccess(value);
    if (value === 'right-away') {
      setAccessDate(null);
    } else {
      setAccessDate(moment(accessDateAsync).toDate());
    }
  };
  const handlePaperStatements = async () => {
    if (store.company.companyFeatureStore.isAppfolio && companyData && !companyData.addressId) {
      setShowCompanyAddressMessage(true);
      toast('warning', {
        body: ['Company address is missing at company details.']
      });
      return;
    }
    if (store.company.companyFeatureStore.isAppfolio && (!paperStatementGl || paperStatementGl.length === 0)) {
      setShowPaperStatementMessage(true);
      toast('warning', {
        body: ['Paper Statement GL Code is not set yet.']
      });
      return;
    }
    let automaticallySendPaperStatementsNewValue = !automaticallySendPaperStatements;
    setIsLoading(true);
    setAutomaticallySendPaperStatements(automaticallySendPaperStatementsNewValue);
    const res = await store.residencies.putResidencyPaperCorrespondenceSettingAsync.run({
      residencyId: residencyId,
      mailingAddress: null,
      automaticallySendPaperStatements: automaticallySendPaperStatementsNewValue,
      automaticallySendPaperInvitations
    });
    if (res !== null && res !== void 0 && res.isSuccessful) {
      toast('success', {
        body: ['Paper communication settings.', 'Successfully saved!']
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      parentToggleRefreshCallback && parentToggleRefreshCallback();
    } else {
      setAutomaticallySendPaperStatements(!automaticallySendPaperStatementsNewValue);
    }
    setIsLoading(false);
  };
  const handleSetStartDate = value => {
    setStartDate(value ? value : null);
    store.residencies.changeBillingSettingsbillingStartDateResultData(value ? formatISO(value).split('T')[0] : null);
  };
  const utilityHandleChange = (id, type) => {
    store.residencies.changeBillingSettingsUtilitiesResultData(id, type);
  };
  const utilityCapHandleChange = (id, type) => {
    store.residencies.changeUtilitiesCapResultData(id, type);
  };
  const fetchResidencyPaperCorrespondenceSetting = async () => {
    setIsLoading(true);
    const propertyDataResp = await store.properties.getPropertyAsync.run({
      propertyId: propertyId
    });
    if (propertyDataResp !== null && propertyDataResp !== void 0 && propertyDataResp.isSuccessful) {
      setPropertyAddress(propertyDataResp.response.propertyAddress);
    }
    const respPaperCorrespondenceSetting = await store.residencies.getResidencyPaperCorrespondenceSettingAsync.run({
      residencyId: residencyId
    });
    if (respPaperCorrespondenceSetting !== null && respPaperCorrespondenceSetting !== void 0 && respPaperCorrespondenceSetting.isSuccessful) {
      var _respPaperCorresponde, _respPaperCorresponde2;
      setAutomaticallySendPaperInvitations(!!respPaperCorrespondenceSetting.response.automaticallySendPaperInvitations);
      setAutomaticallySendPaperStatements(!!respPaperCorrespondenceSetting.response.automaticallySendPaperStatements);
      if (!!(respPaperCorrespondenceSetting !== null && respPaperCorrespondenceSetting !== void 0 && (_respPaperCorresponde = respPaperCorrespondenceSetting.response) !== null && _respPaperCorresponde !== void 0 && _respPaperCorresponde.paperInviteLastSent) && respPaperCorrespondenceSetting !== null && respPaperCorrespondenceSetting !== void 0 && (_respPaperCorresponde2 = respPaperCorrespondenceSetting.response) !== null && _respPaperCorresponde2 !== void 0 && _respPaperCorresponde2.paperInviteLastSent.length) {
        setPaperInviteLastSent(dateToFormat(respPaperCorrespondenceSetting.response.paperInviteLastSent));
      }
    }
    setIsLoading(false);
  };
  const getPropertyFees = async () => {
    const resp = await store.properties.getPropertyFeesV2Async.run({
      applyToStore: true,
      applyToHomeDashboard: false,
      propertyId
    });
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  const getResidencyFee = async () => {
    const resp = await store.payment.getResidencyFeeAsync.run({
      residencyId
    });
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  const updateResidencyFee = async data => {
    const updateResidencyFeeResp = await store.payment.updateResidencyFeeAsync.run(_objectSpread(_objectSpread({}, data), {}, {
      residencyId
    }));
    return updateResidencyFeeResp;
  };
  const asyncDataLoading = async () => {
    var _resp$response, _singleElementOfArray, _singleElementOfArray2, _singleElementOfArray4, _singleElementOfArray5, _singleElementOfArray11;
    setIsLoading(true);
    const _await$Promise$all = await Promise.all([store.residencies.getResidencyBillingSettingsAsync.run({
        residencyId: residencyId
      }), store.payment.getResidentPaymentSettingsAsync.run({
        residencyId: residencyId
      }), getResidencyFee(), getPropertyFees()]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 4),
      resp = _await$Promise$all2[0],
      getResidentPaymentSettingsResp = _await$Promise$all2[1],
      getResidencyFeeResp = _await$Promise$all2[2],
      getPropertyFeesResp = _await$Promise$all2[3];
    if (!resp || !resp.isSuccessful || !getResidentPaymentSettingsResp || !getResidentPaymentSettingsResp.isSuccessful) {
      return;
    }
    if (getResidentPaymentSettingsResp !== null && getResidentPaymentSettingsResp !== void 0 && getResidentPaymentSettingsResp.response) {
      const resPaymentSetting = getResidentPaymentSettingsResp === null || getResidentPaymentSettingsResp === void 0 ? void 0 : getResidentPaymentSettingsResp.response;
      await store.residencies.setBillingSettingsStatementCap(resPaymentSetting.statementCap);
    }
    if (getPropertyFeesResp !== null && getPropertyFeesResp !== void 0 && getPropertyFeesResp.adminFee) {
      setPropertyAdminFee(getPropertyFeesResp.adminFee.value);
    }
    if (getResidencyFeeResp !== null && getResidencyFeeResp !== void 0 && getResidencyFeeResp.adminFee) {
      var _getResidencyFeeResp$;
      setCustomAdminFee((_getResidencyFeeResp$ = getResidencyFeeResp.adminFee) === null || _getResidencyFeeResp$ === void 0 ? void 0 : _getResidencyFeeResp$.value);
    }
    if (getPropertyFeesResp !== null && getPropertyFeesResp !== void 0 && getPropertyFeesResp.lateFee) {
      setPropertyLateFee(getPropertyFeesResp.lateFee.value);
      setCustomLateFeeSign(getPropertyFeesResp.lateFee.feeUnitType);
    }
    if (getResidencyFeeResp !== null && getResidencyFeeResp !== void 0 && getResidencyFeeResp.lateFee) {
      var _getResidencyFeeResp$2;
      setCustomLateFee((_getResidencyFeeResp$2 = getResidencyFeeResp.lateFee) === null || _getResidencyFeeResp$2 === void 0 ? void 0 : _getResidencyFeeResp$2.value);
      setCustomLateFeeSign(getResidencyFeeResp.lateFee.feeUnitType);
    }
    const residencyUtilities = [];
    const residencyUtilityOptOuts = [];
    if (resp.response.residencyUtilities.length) {
      resp.response.residencyUtilities.map(item => {
        residencyUtilities.push({
          icon: getUtility(item.utilityTypeName).icon(),
          name: item.utilityTypeName,
          providerName: item.utilityProviderName,
          value: 'Ratio billing',
          utilityCap: item.utilityCap
        });
      });
    }
    if (resp.response.residencyUtilityOptOuts.length) {
      resp.response.residencyUtilityOptOuts.map(item => {
        residencyUtilityOptOuts.push({
          icon: getUtility(item.utilityTypeName).icon(),
          name: item.utilityTypeName,
          providerName: item.utilityProviderName,
          value: 'Opt-out',
          utilityCap: item.utilityCap
        });
      });
    }
    const fastResidentPortalAccess = {
      name: 'Resident portal access',
      value: 'Resident has no email',
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "access-key",
        state: "lightGrey"
      })
    };
    setStartDate(resp !== null && resp !== void 0 && (_resp$response = resp.response) !== null && _resp$response !== void 0 && _resp$response.billingStartDateOnly ? moment(resp.response.billingStartDateOnly).toDate() : null);
    const addressesData = [];
    const residencyAddressesResp = await store.residencies.getResidencyAddressesAsync.run({
      residencyId: residencyId
    });
    const residencyAddressesIds = residencyAddressesResp.response.map(i => i.addressId);
    const addressResp = await store.address.batchGetAddressesAsync.run({
      addressIds: residencyAddressesIds
    });
    residencyAddressesResp.response.map(i => {
      const cData = i;
      cData.details = addressResp.response.find(e => e.addressId === i.addressId);
      addressesData.push(cData);
    });
    setAddresses(addressesData);
    const userProfileAsync = await store.account.getUsersProfilesAsync.run({
      accountIds: [accountId]
    });
    setAccessEmail((_singleElementOfArray = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.emailConfirmed);
    if ((_singleElementOfArray2 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray2 !== void 0 && _singleElementOfArray2.newEmail) {
      var _singleElementOfArray3;
      setNewEmail((_singleElementOfArray3 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray3 === void 0 ? void 0 : _singleElementOfArray3.newEmail);
    }
    if ((_singleElementOfArray4 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray4 !== void 0 && _singleElementOfArray4.email || (_singleElementOfArray5 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray5 !== void 0 && _singleElementOfArray5.newEmail) {
      var _singleElementOfArray6, _singleElementOfArray7, _singleElementOfArray8, _singleElementOfArray9, _singleElementOfArray0, _singleElementOfArray1, _singleElementOfArray10;
      setEmail((_singleElementOfArray6 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray6 !== void 0 && _singleElementOfArray6.email ? (_singleElementOfArray7 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray7 === void 0 ? void 0 : _singleElementOfArray7.email : (_singleElementOfArray8 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray8 === void 0 ? void 0 : _singleElementOfArray8.newEmail);
      fastResidentPortalAccess.icon = (_singleElementOfArray9 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray9 !== void 0 && _singleElementOfArray9.emailConfirmed ? /*#__PURE__*/React.createElement(Icon, {
        state: "success",
        type: "access-key"
      }) : /*#__PURE__*/React.createElement(Icon, {
        state: "warning",
        type: "access-key"
      });
      fastResidentPortalAccess.value = (_singleElementOfArray0 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray0 !== void 0 && _singleElementOfArray0.email ? (_singleElementOfArray1 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray1 === void 0 ? void 0 : _singleElementOfArray1.email : (_singleElementOfArray10 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray10 === void 0 ? void 0 : _singleElementOfArray10.newEmail;
    }
    if ((_singleElementOfArray11 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) !== null && _singleElementOfArray11 !== void 0 && _singleElementOfArray11.portalAccessDateOnly) {
      var _singleElementOfArray12, _singleElementOfArray13, _singleElementOfArray14;
      setAccessDate(moment((_singleElementOfArray12 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray12 === void 0 ? void 0 : _singleElementOfArray12.portalAccessDateOnly).toDate());
      setAccessDateAsync((_singleElementOfArray13 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray13 === void 0 ? void 0 : _singleElementOfArray13.portalAccessDateOnly);
      fastResidentPortalAccess.icon = /*#__PURE__*/React.createElement(Icon, {
        state: "lightGrey",
        type: "access-key"
      });
      fastResidentPortalAccess.value = dateToFormat((_singleElementOfArray14 = singleElementOfArray(userProfileAsync === null || userProfileAsync === void 0 ? void 0 : userProfileAsync.response)) === null || _singleElementOfArray14 === void 0 ? void 0 : _singleElementOfArray14.portalAccessDateOnly);
    }
    if (store.company.companyFeatureStore.isAppfolio) {
      const companyResp = await store.company.getCurrentUserCompanyFromTokenAsync.run();
      if (companyResp && companyResp.isSuccessful) {
        setCompanyData(companyResp.response);
      }
      const glProperties = await store.credentials.getAppfolioPropertiesAsync.run({});
      const currentGlProperty = glProperties.response.find(glItem => glItem.propertyLivableId === propertyId);
      if (currentGlProperty !== null && currentGlProperty !== void 0 && currentGlProperty.paperStatementFeeGlAccountExternalId) {
        setPaperStatementGl(currentGlProperty === null || currentGlProperty === void 0 ? void 0 : currentGlProperty.paperStatementFeeGlAccountExternalId);
      }
    }
    let resultSettingsList;
    if (!store.company.companyFeatureStore.disableStatementCap) {
      var _getResidentPaymentSe, _getResidentPaymentSe2;
      resultSettingsList = [...residencyUtilities, {
        name: t('enrollment_modal.statement_cap'),
        value: (getResidentPaymentSettingsResp === null || getResidentPaymentSettingsResp === void 0 || (_getResidentPaymentSe = getResidentPaymentSettingsResp.response) === null || _getResidentPaymentSe === void 0 ? void 0 : _getResidentPaymentSe.statementCap) !== null ? "$".concat(Number(getResidentPaymentSettingsResp === null || getResidentPaymentSettingsResp === void 0 || (_getResidentPaymentSe2 = getResidentPaymentSettingsResp.response) === null || _getResidentPaymentSe2 === void 0 ? void 0 : _getResidentPaymentSe2.statementCap).toFixed(2)) : t('allocations.not_set'),
        icon: /*#__PURE__*/React.createElement(Icon, {
          state: "lightGrey",
          type: "coins-in-hand"
        })
      }, ...residencyUtilityOptOuts, {
        name: t('unit_modal.billing_start_date'),
        value: resp.response.billingStartDateOnly ? dateToFormat(resp.response.billingStartDateOnly) : 'N/A',
        icon: /*#__PURE__*/React.createElement(Icon, {
          state: "lightGrey",
          type: "calendar-picker"
        })
      }, fastResidentPortalAccess];
    } else {
      resultSettingsList = [...residencyUtilities, ...residencyUtilityOptOuts, {
        name: t('unit_modal.billing_start_date'),
        value: resp.response.billingStartDateOnly ? dateToFormat(resp.response.billingStartDateOnly) : 'N/A',
        icon: /*#__PURE__*/React.createElement(Icon, {
          state: "lightGrey",
          type: "calendar-picker"
        })
      }, fastResidentPortalAccess];
    }
    setSettingsList(resultSettingsList);
    await fetchResidencyPaperCorrespondenceSetting();
    setIsLoading(false);
  };
  const handleResendPaperInvitationAsync = async () => {
    setIsLoading(true);
    const resp = await store.residencies.resendPaperInvitationAsync.run({
      residencyId: residencyId
    });
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      toast('success', {
        body: ['Paper invite was sent.']
      });
      await fetchResidencyPaperCorrespondenceSetting();
    }
    setIsLoading(false);
  };
  const handleSubmit = async () => {
    let isChanges = false;
    const formatAccessDate = accessDate ? formatISO(accessDate).split('T')[0] : null;
    if (store.residencies.billingSettingsDetails.statementCap !== store.residencies.billingSettingsResultData.statementCap) {
      isChanges = true;
      const resp = await store.payment.putResidentPaymentSettingsAsync.run({
        residencyId: residencyId,
        statementCap: store.residencies.billingSettingsResultData.statementCap
      });
      if (!resp || !resp.isSuccessful) {
        return;
      }
    }
    if (store.residencies.billingSettingsDetails.billingStartDateOnly !== store.residencies.billingSettingsResultData.billingStartDateOnly) {
      isChanges = true;
    } else {
      toJS(store.residencies.billingSettingsResultData).utilities.map(i => {
        if (i.utilityType === 'RatioBilling') {
          if (toJS(store.residencies.billingSettingsDetails.residencyUtilities).findIndex(utility => utility.utilityId === i.utilityId) === -1) {
            isChanges = true;
          }
        } else {
          if (toJS(store.residencies.billingSettingsDetails.residencyUtilityOptOuts).findIndex(utility => utility.utilityId === i.utilityId) === -1) {
            isChanges = true;
          }
        }
      });
    }
    if (!isChanges) {
      toJS(store.residencies.billingSettingsResultData.utilities.map(utility => {
        if (!isChanges) {
          isChanges = utility.utilityCap !== toJS(store.residencies.billingSettingsDetails.residencyUtilities).find(i => i.utilityId === utility.utilityId).utilityCap;
        }
      }));
    }
    if (isChanges) {
      const updateResidencyBillingSettingsReqObj = _objectSpread({
        residencyId: residencyId
      }, toJS(store.residencies.billingSettingsResultData));
      if (!store.company.companyFeatureStore.isAppfolio) {
        updateResidencyBillingSettingsReqObj.moveInDateOnly = {
          value: formatISO(startDate).split('T')[0]
        };
      } else {
        delete updateResidencyBillingSettingsReqObj.moveInDateOnly;
      }
      const resp = await store.residencies.updateResidencyBillingSettingsAsync.run(updateResidencyBillingSettingsReqObj);
      if (!resp || !resp.isSuccessful) {
        return;
      }
    }
    if (formatAccessDate !== accessDateAsync) {
      const portalAccessDateAsync = await store.account.updateUsersPortalAccessDateAsync.run({
        accountId: accountId,
        portalAccessDate: formatAccessDate
      });
      if (!portalAccessDateAsync || !portalAccessDateAsync.isSuccessful) {
        return;
      }
    }
    if (isChanges || formatAccessDate !== accessDateAsync) {
      await asyncDataLoading();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      parentToggleRefreshCallback && parentToggleRefreshCallback();
      toast('success', {
        body: ['Successfully saved']
      });
    }
  };
  const getCustomAddress = () => {
    const cIndex = addresses.findIndex(i => i.isPrimary && i.status === RESIDENCY_ADDRESS_STATUS.approved);
    if (cIndex > -1) {
      var _addresses$cIndex$det;
      return "".concat(addresses[cIndex].details.street, " ").concat(addresses[cIndex].details.city, ", ").concat(addresses[cIndex].details.state, " ").concat(addresses[cIndex].details.zip).concat((_addresses$cIndex$det = addresses[cIndex].details) !== null && _addresses$cIndex$det !== void 0 && _addresses$cIndex$det.secondary ? ', ' + addresses[cIndex].details.secondary : '');
    } else {
      return propertyAddress;
    }
  };
  useEffect(() => {
    if (isOpen) asyncDataLoading();
  }, []);
  useEffect(() => {
    if (feeIsUpdated) {
      setIsLoading(true);
      updateResidencyFee({
        adminFee: customAdminFee === null ? null : {
          feeUnitType: FEE_UNIT_TYPES.fixedAmount,
          value: customAdminFee
        },
        lateFee: customLateFee === null ? null : {
          feeUnitType: customLateFeeSign,
          value: customLateFee
        }
      }).then(resp => {
        if (resp.isSuccessful) toast('success', {
          body: ["Custom admin fee successfully saved!"]
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        parentToggleRefreshCallback && parentToggleRefreshCallback();
      }).finally(() => {
        setIsLoading(false);
        setFeeIsUpdated(false);
      });
    }
  }, [feeIsUpdated]);
  useEffect(() => {
    if (fetchAdminFee) getResidencyFee().then(resp => {
      var _resp$adminFee;
      return setCustomAdminFee(resp === null || resp === void 0 || (_resp$adminFee = resp.adminFee) === null || _resp$adminFee === void 0 ? void 0 : _resp$adminFee.value);
    }).finally(() => {
      setIsLoading(false);
      setFetchAdminFee(false);
    });
  }, [fetchAdminFee]);
  useEffect(() => {
    if (fetchLateFee) getResidencyFee().then(resp => {
      var _resp$lateFee;
      return setCustomLateFee(resp === null || resp === void 0 || (_resp$lateFee = resp.lateFee) === null || _resp$lateFee === void 0 ? void 0 : _resp$lateFee.value);
    }).finally(() => {
      setIsLoading(false);
      setFetchLateFee(false);
    });
  }, [fetchLateFee]);
  const handleSave = async (lateFee, value) => {
    if (value >= 0) {
      if (lateFee) setCustomLateFee(value);else setCustomAdminFee(value);
      setFeeIsUpdated(true);
    }
  };
  const billingHint = check => {
    return check ? /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: t('unit_modal.billing_start_date_explanation'),
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, {
      className: classes.inlineTooltip
    }, /*#__PURE__*/React.createElement(Icon, {
      state: "info",
      type: "info"
    }))) : null;
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListStatusHeader, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "move-in"
    }),
    title: t('unit_modal.enrolled_in_bill')
    // title={`Enrollment is scheduled (${
    //   store.residencies.billingSettingsDetails.billingType === 0
    //     ? 'Sample Statement'
    //     : 'Bill'
    // })`}
    ,
    status: "info",
    enableEdit: true,
    editModeIsOn: settingsEditMode,
    handleEditClick: setSettingsEditMode,
    handleSubmit: handleSubmit,
    type: "large"
  }), !settingsEditMode && /*#__PURE__*/React.createElement(React.Fragment, null, settingsList.map(listItem => /*#__PURE__*/React.createElement(ListItem, {
    key: listItem.name
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: "iconWrapper"
  }, listItem.icon), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "".concat(listItem.name).concat(listItem.providerName ? " (".concat(listItem.providerName, ")") : ''), billingHint(listItem.name === t('unit_modal.billing_start_date')))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.cap
  }, listItem.utilityCap === null || listItem.utilityCap === undefined ? listItem.value : listItem.value + " (CAP: ".concat(Number(listItem.utilityCap).toFixed(2), ")")))), !store.company.companyFeatureStore.disableSendPaperInvite && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: "iconWrapper"
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "mail-post"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('unit_modal.paper_invite'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.cap
  }, paperInviteLastSent && paperInviteLastSent.length ? 'Sent' : t('unit_modal.not_sent')))), settingsEditMode && /*#__PURE__*/React.createElement("div", {
    className: classes.editableContentBlock
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: enrollType,
    exclusive: true,
    onChange: (e, value) => {
      if (value) setEnrollType(value);
    }
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "bill"
  }, t('unit_modal.bill')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "sample-statement",
    disabled: true
  }, t('unit_modal.sample_statement'), " ", "(Coming soon)")), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('unit_modal.if_unit_is_opted_out'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  })), enrollType === 'bill' && /*#__PURE__*/React.createElement(React.Fragment, null, store.residencies.billingSettingsDetails.residencyUtilities.length > 0 && store.residencies.billingSettingsDetails.residencyUtilities.map(item => /*#__PURE__*/React.createElement(Utility, {
    type: 0,
    key: "residencyUtilities-".concat(item.utilityId),
    utilityId: item.utilityId,
    handleChange: utilityHandleChange,
    providerName: item.utilityProviderName,
    utility: item.utilityTypeName.toLocaleLowerCase(),
    utilityCapExternal: item.utilityCap,
    handleCapChange: utilityCapHandleChange
  })), store.residencies.billingSettingsDetails.residencyUtilityOptOuts.length > 0 && store.residencies.billingSettingsDetails.residencyUtilityOptOuts.map(item => /*#__PURE__*/React.createElement(Utility, {
    type: 1,
    key: "residencyUtilityOptOuts-".concat(item.utilityId),
    utilityId: item.utilityId,
    handleChange: utilityHandleChange,
    providerName: item.utilityProviderName,
    utility: item.utilityTypeName.toLocaleLowerCase(),
    utilityCapExternal: item.utilityCap,
    handleCapChange: utilityCapHandleChange
  }))), !store.company.companyFeatureStore.disableStatementCap ? /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flex, " ").concat(classes.summaryWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.statementCap
  }, /*#__PURE__*/React.createElement("span", {
    className: "iconWrapper"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins-in-hand"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('enrollment_modal.statement_cap'))), /*#__PURE__*/React.createElement(FinancialTextInput, {
    inputLabel: t('enrollment_modal.statement_input_label'),
    valueExt: store.residencies.billingSettingsDetails.statementCap,
    handleInputChange: value => {
      store.residencies.changeStatementCapResultData(value);
    },
    refresh: true,
    withAdorment: true,
    infoMark: t('enrollment_modal.statement_cap_help_info'),
    infoMarkNullPaddingMargin: false
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('unit_modal.billing_start_date'), billingHint(true))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('unit_modal.billing_start_date_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: startDate,
    onChange: date => handleSetStartDate(date),
    format: "MM/dd/yy",
    label: t('unit_modal.service_start')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('unit_modal.resident_portal_access'))), !accessDateAsync && !accessEmail && !email && !newEmail && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.additionInfo
  }, t('unit_modal.resident_has_no_email')), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: e => {
      handleTabChange(e, 'personal-details');
    },
    'custom-attribute': '248-BillingSettingsTab'
  }, t('unit_modal.open_personal_details'))), !accessDateAsync && (email || newEmail) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.whiteBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "mail"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "".concat(t('general.email'), ": ").concat(email ? email : newEmail))), accessEmail ? /*#__PURE__*/React.createElement(AccessPortal, {
    tooltipText: t('unit_modal.has_access_to_rp'),
    type: "success"
  }) : /*#__PURE__*/React.createElement(AccessPortal, {
    tooltipText: t('unit_modal.pending_rp_invite'),
    type: "warning"
  }))), !store.company.companyFeatureStore.disableSendPaperInvite && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.whiteBox
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "mail-send"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, getCustomAddress())), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: paperInviteLastSent.length ? "Last invited: ".concat(paperInviteLastSent) : 'Currently there is no Paper Invite sent',
    type: paperInviteLastSent.length ? 'success-bold' : 'default'
  }, /*#__PURE__*/React.createElement(Chip, {
    color: "success",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-post"
    }),
    variant: paperInviteLastSent.length ? 'portal' : 'inactiveIcon',
    size: "big"
  }))), !store.company.companyFeatureStore.disableSendPaperInvite && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    label: t('unit_modal.you_will_be_charged'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "info"
  })), !store.company.companyFeatureStore.disableSendPaperInvite && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: handleResendPaperInvitationAsync,
    'custom-attribute': '249-BillingSettingsTab'
  }, paperInviteLastSent.length ? t('unit_modal.send_invite_again') : 'Send paper invite'))), accessDateAsync && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: portalAccess,
    onChange: handlePortalAccessChange,
    size: "small",
    exclusive: true,
    disabled: store.company.companyFeatureStore.readOnlyResidentPortalAccess
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "right-away",
    'custom-attribute': '249-BillingSettingsTab-right-away'
  }, t('unit_modal.send_right_away')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "custom-date",
    'custom-attribute': '249-BillingSettingsTab-custom-date'
  }, t('unit_modal.set_custom_date')))), portalAccess === 'custom-date' && /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.datePicker, " ").concat(store.company.companyFeatureStore.readOnlyResidentPortalAccess ? 'disabled' : '')
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: accessDate,
    onChange: date => setAccessDate(date),
    format: "MM/dd/yy",
    label: t('unit_modal.give_access_on'),
    minDate: moment().toDate()
  })))))), /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(BillingSettingsCustomFee, {
    customAdminFee: customAdminFee >= 0 ? customAdminFee : null,
    customFee: customAdminFee >= 0 ? customAdminFee : null,
    customLateFee: customLateFee >= 0 ? customLateFee : null,
    feeDescription: t('unit_modal.custom_fee'),
    handleChange: fee => setCustomAdminFee(fee),
    handleSave: handleSave,
    padding: "12px 24px",
    propertyAdminFee: propertyAdminFee,
    residencyId: residencyId,
    setFetchFee: setFetchAdminFee,
    setIsLoading: setIsLoading
  })), !store.company.companyFeatureStore.isAppfolio && !store.company.companyFeatureStore.convergentBillingMode && /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(BillingSettingsCustomFee, {
    customAdminFee: customAdminFee >= 0 ? customAdminFee : null,
    customFee: customLateFee >= 0 ? customLateFee : null,
    customLateFee: customLateFee >= 0 ? customLateFee : null,
    customLateFeeSign: customLateFeeSign,
    handleChange: fee => setCustomLateFee(fee),
    handleCustomLateFeeSignChange: setCustomLateFeeSign,
    handleSave: handleSave,
    feeDescription: t('unit_modal.custom_fee'),
    lateFee: true,
    padding: "12px 24px",
    propertyLateFee: propertyLateFee,
    residencyId: residencyId,
    setFetchFee: setFetchLateFee,
    setIsLoading: setIsLoading
  })), !settingsEditMode && !store.company.companyFeatureStore.disablePaperCorrespondence && /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListStatusHeader, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "mail-paper"
    }),
    title: t('unit_modal.paper_statements')
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: automaticallySendPaperStatements,
    onChange: handlePaperStatements
  }))), store.company.companyFeatureStore.isAppfolio && showCompanyAddressMessage && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    sx: {
      '& .MuiChip-label': {
        fontSize: 12,
        lineHeight: '18px'
      }
    },
    label: t('unit_modal.company_address_missing'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "warning"
  })), store.company.companyFeatureStore.isAppfolio && showPaperStatementMessage && /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Chip, {
    sx: {
      '& .MuiChip-label': {
        fontSize: 12,
        lineHeight: '18px'
      }
    },
    label: t('unit_modal.paper_statement_gl_missing'),
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    variant: "warning"
  })), !(store.company.companyFeatureStore.disablePaperStatementFee || (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.disablePaperStatementFee) && /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('unit_modal.paper_statement_fee')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "$2.00")), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('unit_modal.mailing_address')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, getCustomAddress()))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading || store.account.getUsersProfilesAsync.inProgress || store.account.updateUsersPortalAccessDateAsync.inProgress || store.residencies.updateResidencyBillingSettingsAsync.inProgress || store.residencies.getResidencyBillingSettingsAsync.inProgress
  }));
});